import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Messages from '../messages';
import style from './style.css';

export class FormInline extends React.Component {

  static propTypes = {
    dom: PropTypes.string.isRequired
  };

  static defaultProps = {
    dom: 'form'
  };

  render() {
    let {className, dom: DOM, ...props} = this.props;
    className = classNames(className, style.formInline);
    return <DOM {...props} className={className} />;
  }

}

export class FormHorizental extends React.Component {

  static propTypes = {
    className: PropTypes.string,
    children: PropTypes.node.isRequired,
    invalid: PropTypes.bool.isRequired
  };

  static defaultProps = {
    invalid: false
  };

  render() {
    let {className, invalid, children, ...props} = this.props;
    className = classNames(className, style.formHorizontal);
    return <form {...props} className={className}>
      {invalid ? <Messages messages={[{
        text: 'Please fix following errors.',
        level: 'error'
      }]} /> : null}
      {children}
    </form>;
  }

}



// WEBPACK FOOTER //
// ./src/views/fragments/forms/form.js